import { render } from "./CreateBidSend.vue?vue&type=template&id=7c60a6ef"
import script from "./CreateBidSend.vue?vue&type=script&lang=js"
export * from "./CreateBidSend.vue?vue&type=script&lang=js"

import "./CreateBidSend.vue?vue&type=style&index=0&id=7c60a6ef&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__